// @ts-nocheck
import { Tooltip, TooltipContent, TooltipTrigger } from '@ophelos/ui/components/tooltip';
import { useEffect, useRef } from 'react';
import { AIIcon } from '@/components/icons/AIIcon';
import { useAIChat } from '@/contexts/AIChatContext';

export function AIChatTrigger() {
  const { isOpen, showTrigger, open } = useAIChat();
  const fabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen || !showTrigger) {
      document.documentElement.style.removeProperty('--fab-clearance');
      return;
    }
    const el = fabRef.current;
    if (!el) return;
    const update = () => {
      const w = el.offsetWidth;
      const right = parseFloat(getComputedStyle(el).right) || 0;
      document.documentElement.style.setProperty('--fab-clearance', `${w + right + 8}px`);
    };
    update();
    return () => document.documentElement.style.removeProperty('--fab-clearance');
  }, [isOpen, showTrigger]);

  if (isOpen || !showTrigger) return null;

  const handleOpen = () => {
    open();
  };

  return (
    <div ref={fabRef} className="fixed bottom-6 right-6 z-50 hidden md:block">
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            role="button"
            tabIndex={0}
            aria-label="Open AI chat"
            onClick={handleOpen}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') handleOpen();
            }}
            style={{
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
            }}
            className="size-10 cursor-pointer border group rounded-full overflow-hidden shadow-lg bg-card border-ring/25 transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-[0_2px_16px_-4px_var(--brand-300)] hover:bg-[linear-gradient(var(--card),var(--card)),linear-gradient(to_bottom_right,var(--brand-300),var(--brand-500),#f472b6)] flex items-center justify-center"
          >
            <AIIcon className="size-6 text-accent-foreground/60 transition-all duration-500 ease-in-out group-hover:text-brand-500 group-hover:rotate-6 group-hover:scale-110" />
          </div>
        </TooltipTrigger>
        <TooltipContent side="left">AI Support</TooltipContent>
      </Tooltip>
    </div>
  );
}
